import { render, staticRenderFns } from "./simpleSnotifyWarning.vue?vue&type=template&id=6ac98c96&scoped=true"
import script from "./simpleSnotifyWarning.vue?vue&type=script&scoped=true&lang=js"
export * from "./simpleSnotifyWarning.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./simpleSnotifyWarning.vue?vue&type=style&index=0&id=6ac98c96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac98c96",
  null
  
)

export default component.exports